import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatCheckbox } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { CommentService } from '../../services/comment.service';

@Component({
  selector: 'app-contacto',
  imports: [CommonModule, MatIconModule, MatInputModule, MatError, MatFormField, MatLabel,
    MatSelect, MatOption, MatCheckbox, ReactiveFormsModule, TranslateModule],
  templateUrl: './contacto.component.html',
  styleUrl: './contacto.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ContactoComponent implements OnInit {

  contactForm: FormGroup;
  showOrderNumber: boolean = false;

  constructor(private fb: FormBuilder, private commentService: CommentService) {
    this.contactForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.pattern(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/)],
      reason: ['general', Validators.required],
      message: ['', [Validators.required, Validators.minLength(10)]],
      newsletter: [false],
      allowContact: [false],
      orderNumber: [0]
    });
  }
  ngOnInit(): void {
    this.contactForm.controls['reason'].valueChanges.subscribe(reason => {
      if (reason === 'purchase-problem') {
        this.showOrderNumber = true;
        this.contactForm.controls['orderNumber'].clearValidators();
        this.contactForm.controls['orderNumber'].addValidators([Validators.min(1), Validators.max(999999999), Validators.required]);
        this.contactForm.controls['orderNumber'].updateValueAndValidity();
        this.contactForm.controls['allowContact'].clearValidators();
        this.contactForm.controls['allowContact'].addValidators(Validators.requiredTrue);
        this.contactForm.controls['allowContact'].updateValueAndValidity();
      } else {
        this.showOrderNumber = false;
        this.contactForm.controls['orderNumber'].setValue(0);
        this.contactForm.controls['orderNumber'].clearValidators();
        this.contactForm.controls['allowContact'].clearValidators();
        this.contactForm.controls['orderNumber'].updateValueAndValidity();
        this.contactForm.controls['allowContact'].updateValueAndValidity();
      }
    });
  }


  onSubmit(): void {
    if (this.contactForm.valid) {
      console.log('Formulario contacto:', this.contactForm.value);
      this.commentService.crearComentario(this.contactForm.value).subscribe(() => {
        alert('Recibimos tu mensaje. ¡Muchas gracias!');
        this.resetForm();
      });
    } else {
      this.contactForm.updateValueAndValidity();
      this.contactForm.markAllAsTouched();
    }
  }

  resetForm(): void {
    this.contactForm.reset({
      reason: 'general',
      newsletter: false,
      allowContact: false,
      orderNumber: 0
    });
    this.contactForm.updateValueAndValidity();
    this.contactForm.markAsPristine();
    this.contactForm.markAsUntouched();
    Object.keys(this.contactForm.controls).forEach((key: string) => {
      this.contactForm.controls[key].setErrors(null);
      this.contactForm.controls[key].updateValueAndValidity();
      this.contactForm.controls[key].markAsUntouched();
      this.contactForm.controls[key].markAsPristine();
    });
  }
}